import { withStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";

export const BtnIngresarDatos = withStyles((theme) => ({
  root: {
    background: "linear-gradient(to left,#015190,#00ac92)",
    border: "none",
    color: "white",
    "&:hover": {
      background: " linear-gradient(to left,#29436b,#47b1a1)",
      border: "none",
    },
  },
  label: {
    textTransform: "none",
  },
}))(Button);
